import {BaseModalComponent, IdCodeNameModel} from "common-shared";
import {Component} from "@angular/core";
import {PropertyModel, PropertyUsages} from "../../../properties/models/property.model";

@Component({
  selector: 'mes-property-usages-modal',
  templateUrl: './property-usages-modal.component.html'
})
export class PropertyUsagesModalComponent extends BaseModalComponent {

  usages: PropertyUsages;
  property: PropertyModel;
  allUsageTypes: PropertyUsageType[];


  constructor() {
    super();
  }

  ngOnInit(): void {
    this.allUsageTypes = Object.entries(this.usages)
      .filter(x => x[1] && x[1].length && (x[1] as Array<IdCodeNameModel>))
      .map(x => new PropertyUsageType(this.pascalToSpaced(x[0]), x[1]));
  }

  private pascalToSpaced(source: string) {
    return source.replace(/([A-Z])/g, ' $1').trimStart();
  }
}

class PropertyUsageType {
  constructor(public TranslationKey: string, public Instances: IdCodeNameModel[]) {
  }
}
